<div class="loading-overlay" *ngIf="cargando" aria-live="polite" aria-busy="true">
    <div class="loading-content" role="status" aria-label="Cargando">
        <div class="loader-ellipsis" aria-hidden="true">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div class="loading-title" aria-hidden="true">Cargando</div>
        <span class="sr-only">Cargando…</span>
    </div>
</div>

<section class="acreditacion-page">
    <div class="container">

        <p class="acreditacion-kicker">Tesorería Municipal · Pago en línea</p>

        <article class="comprobante" [ngClass]="'comprobante--' + estado" aria-live="polite">

            <!-- ── Estado ── -->
            <header class="comprobante__estado">
                <div class="estado-icono" aria-hidden="true">
                    <ng-container [ngSwitch]="estado">
                        <span *ngSwitchCase="'verificando'" class="estado-spinner"></span>
                        <i *ngSwitchCase="'acreditado'" class="fa-solid fa-check"></i>
                        <i *ngSwitchCase="'rechazado'" class="fa-solid fa-xmark"></i>
                        <i *ngSwitchCase="'expirado'" class="fa-solid fa-hourglass-end"></i>
                        <i *ngSwitchCase="'sin_pago'" class="fa-solid fa-arrow-rotate-left"></i>
                        <i *ngSwitchCase="'revision'" class="fa-solid fa-magnifying-glass"></i>
                        <i *ngSwitchCase="'sin_orden'" class="fa-solid fa-question"></i>
                        <i *ngSwitchDefault class="fa-solid fa-clock"></i>
                    </ng-container>
                </div>

                <ng-container [ngSwitch]="estado">
                    <ng-container *ngSwitchCase="'verificando'">
                        <h1 class="estado-titulo">Verificando su pago</h1>
                        <p class="estado-texto">Estamos confirmando la operación con el banco. No cierre esta ventana.</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'acreditado'">
                        <h1 class="estado-titulo">¡Pago acreditado!</h1>
                        <p class="estado-texto">Su pago fue registrado correctamente. Gracias por utilizar los servicios electrónicos de nuestro portal.</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'rechazado'">
                        <h1 class="estado-titulo">Pago no aprobado</h1>
                        <p class="estado-texto">El banco no autorizó la operación y no se realizó ningún cargo. Puede intentarlo de nuevo con otra tarjeta.</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'expirado'">
                        <h1 class="estado-titulo">El enlace de pago expiró</h1>
                        <p class="estado-texto">Consulte de nuevo su clave catastral para generar un nuevo pago.</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'sin_pago'">
                        <h1 class="estado-titulo">No se realizó el pago</h1>
                        <p class="estado-texto">Salió de la ventana de pago antes de completarlo, así que no se hizo ningún cargo. Puede intentarlo de nuevo cuando quiera.</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'revision'">
                        <h1 class="estado-titulo">Pago en revisión</h1>
                        <p class="estado-texto">Recibimos su pago, pero el recibo requiere una validación adicional. Comuníquese con Tesorería indicando su referencia.</p>
                    </ng-container>
                    <ng-container *ngSwitchCase="'sin_orden'">
                        <h1 class="estado-titulo">No encontramos el pago</h1>
                        <p class="estado-texto">No hay un pago registrado con esta referencia. Si ya pagó, verifique de nuevo en unos minutos.</p>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <h1 class="estado-titulo">Pago en confirmación</h1>
                        <p class="estado-texto">El banco aún no confirma la operación. Presione «Verificar de nuevo» en unos momentos.</p>
                    </ng-container>
                </ng-container>

                <div class="estado-importe" *ngIf="esFinalExitoso && importe != null">
                    <span class="estado-importe__label">Importe pagado</span>
                    <span class="estado-importe__valor">{{ importe | currency:'MXN':'symbol-narrow':'1.2-2' }} <small>MXN</small></span>
                </div>
            </header>

            <!-- ── Datos del comprobante ── -->
            <div class="comprobante__corte" aria-hidden="true"></div>

            <dl class="comprobante__datos">
                <div class="dato" *ngIf="esFinalExitoso && mostrarFolio">
                    <dt>Folio de recibo</dt>
                    <dd class="dato__destacado">{{ folio_recibo }}</dd>
                </div>
                <div class="dato" *ngIf="esFinalExitoso && mostrarAutorizacion">
                    <dt>Autorización bancaria</dt>
                    <dd>{{ no_autorizacion }}</dd>
                </div>
                <div class="dato dato--ancho">
                    <dt>Referencia de pago</dt>
                    <dd class="dato__referencia">
                        <span class="dato__mono">{{ referencia_pago }}</span>
                        <button type="button" class="btn-copiar" (click)="CopiarReferencia()"
                            [attr.aria-label]="referencia_copiada ? 'Referencia copiada' : 'Copiar referencia'">
                            <i class="fa-solid" [ngClass]="referencia_copiada ? 'fa-check' : 'fa-copy'" aria-hidden="true"></i>
                            <span>{{ referencia_copiada ? 'Copiada' : 'Copiar' }}</span>
                        </button>
                    </dd>
                </div>
                <div class="dato dato--ancho" *ngIf="ente">
                    <dt>Dependencia</dt>
                    <dd>{{ ente }} · Tesorería Municipal</dd>
                </div>
            </dl>

            <!-- ── Acciones ── -->
            <footer class="comprobante__acciones">
                <button type="button" class="btn-accion btn-accion--primaria" *ngIf="esFinalExitoso && mostrarFolio" (click)="ImprimirRecibo()">
                    <i class="fa-solid fa-file-arrow-down" aria-hidden="true"></i> Descargar recibo
                </button>
                <button type="button" class="btn-accion btn-accion--primaria" *ngIf="reintentar && !esFinalExitoso" (click)="Reintentar()">
                    <i class="fa-solid fa-rotate-right" aria-hidden="true"></i> Verificar de nuevo
                </button>
                <button type="button" class="btn-accion btn-accion--secundaria" *ngIf="estado !== 'verificando'" (click)="Regresar()">
                    <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
                    {{ estado === 'rechazado' || estado === 'expirado' || estado === 'sin_pago' ? 'Intentar de nuevo' : 'Consultar otra clave' }}
                </button>
            </footer>
        </article>

        <p class="acreditacion-nota" *ngIf="esFinalExitoso">
            <i class="fa-solid fa-circle-info" aria-hidden="true"></i>
            Conserve su folio y su referencia; los necesitará para cualquier aclaración.
        </p>

        <!-- ── Ayuda ── -->
        <aside class="ayuda" *ngIf="estado !== 'verificando' && ((telefonos && telefonos.length) || (emails && emails.length))">
            <h2 class="ayuda__titulo">¿Necesita ayuda?</h2>
            <div class="ayuda__canales">
                <a class="ayuda__canal" *ngFor="let tel of telefonos" [href]="'tel:' + tel">
                    <i class="fa-solid fa-phone" aria-hidden="true"></i> {{ tel }}
                </a>
                <a class="ayuda__canal" *ngFor="let correo of emails" [href]="'mailto:' + correo">
                    <i class="fa-solid fa-envelope" aria-hidden="true"></i> {{ correo }}
                </a>
            </div>
        </aside>
    </div>
</section>
